export const DEFAULT_CURRENCY = 'EUR';

export const BRAND_CURRENCY_MAP = {};
